import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationEmptyState = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationEmptyState',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_radial_21134_70125)",
    d: "M50.63 76.22c14.663 0 26.55-11.887 26.55-26.55S65.293 23.12 50.63 23.12 24.08 35.007 24.08 49.67s11.887 26.55 26.55 26.55Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m62.77 41.93-5.32-4.55-10.39 12.15-5.09-5.02-4.92 4.98 10.45 10.3 15.27-17.86Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70125)",
    fillRule: "evenodd",
    d: "M49.09 99.25c37.37 0 48.37-32.49 48.37-32.49s-11.26 3.48-20.27 4.42-13.7-.38-21.35-2.76c-7.65-2.38-16.38-7.01-28.58-7.01s-24.32 6.2-24.32 6.2c2.78 8.27 17.63 31.64 46.15 31.64Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_radial_21134_70125)",
    fillRule: "evenodd",
    d: "M48.91 18.1h2.14c1.06 0 1.94-.83 2-1.89l.65-11.34c.07-1.15-.85-2.12-2-2.12h-3.43c-1.15 0-2.06.97-2 2.12l.65 11.34c.05 1.06.92 1.89 1.99 1.89Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_radial_21134_70125)",
    fillRule: "evenodd",
    d: "M17.85 51.3v-2.14c0-1.06-.83-1.94-1.89-2l-11.34-.65c-1.15-.07-2.12.85-2.12 2v3.43c0 1.15.97 2.06 2.12 2l11.34-.65a1.99 1.99 0 0 0 1.89-1.99Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_radial_21134_70125)",
    fillRule: "evenodd",
    d: "M82.11 49.16v2.14c0 1.06.83 1.94 1.89 2l11.34.65c1.15.07 2.12-.85 2.12-2v-3.43c0-1.15-.97-2.06-2.12-2L84 47.16c-1.06.06-1.89.94-1.89 2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint5_radial_21134_70125)",
    fillRule: "evenodd",
    d: "m71.94 26.75 1.52 1.52c.75.75 1.96.78 2.75.08l8.48-7.56c.86-.77.9-2.1.08-2.91l-2.43-2.43c-.81-.81-2.14-.78-2.91.08L71.86 24c-.71.8-.67 2 .08 2.75Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint6_radial_21134_70125)",
    fillRule: "evenodd",
    d: "m26.5 28.27 1.52-1.52c.75-.75.78-1.95.08-2.75l-7.56-8.48c-.77-.86-2.1-.9-2.91-.08l-2.43 2.43c-.81.81-.78 2.14.08 2.91l8.48 7.56c.78.71 1.99.68 2.74-.07Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint0_radial_21134_70125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(47.122 46.837) scale(89.8254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#F3D910"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.05,
    stopColor: "#F6C31D"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.123,
    stopColor: "#F9AB2B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.204,
    stopColor: "#FC9836"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.3,
    stopColor: "#FE8A3D"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.42,
    stopColor: "#FF8242"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.652,
    stopColor: "#FF8043"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70125",
    x1: 34.383,
    x2: 72.322,
    y1: 31.449,
    y2: 117.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#CDFAE4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.104,
    stopColor: "#C5F0E5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.282,
    stopColor: "#B0D5E6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.511,
    stopColor: "#8DA9E9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.762,
    stopColor: "#6071EC"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint2_radial_21134_70125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(47.122 46.837) scale(89.8254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.002,
    stopColor: "#F3D910"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.096,
    stopColor: "#F4D015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.996,
    stopColor: "#FF8043"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint3_radial_21134_70125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(47.122 46.837) scale(89.8254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.002,
    stopColor: "#F3D910"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.096,
    stopColor: "#F4D015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.996,
    stopColor: "#FF8043"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint4_radial_21134_70125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(47.122 46.837) scale(89.8254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.002,
    stopColor: "#F3D910"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.096,
    stopColor: "#F4D015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.996,
    stopColor: "#FF8043"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint5_radial_21134_70125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(47.122 46.837) scale(89.8254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.002,
    stopColor: "#F3D910"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.096,
    stopColor: "#F4D015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.996,
    stopColor: "#FF8043"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint6_radial_21134_70125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(47.122 46.837) scale(89.8254)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.002,
    stopColor: "#F3D910"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.096,
    stopColor: "#F4D015"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.996,
    stopColor: "#FF8043"
  }))));
};
ColoredIllustrationEmptyState.displayName = 'ColoredIllustrationEmptyState';
export default withProvisionalOverrideFromContext(ColoredIllustrationEmptyState);
//# sourceMappingURL=index.js.map